export default __webpack_public_path__ + "static/media/kitchen3-afterK-1024w.ae740df2.avif";